// extracted by mini-css-extract-plugin
export default {"reviews":"ReviewsSlider_reviews__Im4Hr"};